import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button } from '../../../../atoms/Button/Button';
import { Attachment } from '../../../../molecules/Attachment';
import { useAIInput } from '../../AIInputContext';
import './AttachmentListStyles.scss';
/**
 * AttachmentList Component
 * Horizontal carousel of attachment chips with left/right navigation arrows
 * @version 1.0.0
 * @since 2026-02-17
 */
export function AttachmentList({ className = '' }) {
    const { attachments, removeAttachment } = useAIInput();
    const scrollRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const checkScroll = useCallback(() => {
        const el = scrollRef.current;
        if (!el)
            return;
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }, []);
    useEffect(() => {
        checkScroll();
        const el = scrollRef.current;
        if (el && typeof ResizeObserver !== 'undefined') {
            el.addEventListener('scroll', checkScroll);
            const observer = new ResizeObserver(checkScroll);
            observer.observe(el);
            return () => {
                el.removeEventListener('scroll', checkScroll);
                observer.disconnect();
            };
        }
        return undefined;
    }, [checkScroll, attachments.length]);
    const scroll = (direction) => {
        const el = scrollRef.current;
        if (!el)
            return;
        const amount = 200;
        el.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
    };
    if (attachments.length === 0)
        return null;
    const baseClass = 'qmb-ui-attachment-list';
    const combinedClass = [baseClass, className].filter(Boolean).join(' ');
    return (React.createElement("div", { className: combinedClass },
        canScrollLeft && (React.createElement(Button, { className: `${baseClass}__arrow ${baseClass}__arrow--left`, "aria-label": "Scroll attachments left", onClick: () => scroll('left') },
            React.createElement("i", { className: "fa-light fa-chevron-left" }))),
        React.createElement("div", { ref: scrollRef, className: `${baseClass}__scroll` }, attachments.map((attachment) => (React.createElement(Attachment, { key: attachment.id, id: attachment.id, name: attachment.name, type: attachment.type, onRemove: removeAttachment })))),
        canScrollRight && (React.createElement(Button, { className: `${baseClass}__arrow ${baseClass}__arrow--right`, "aria-label": "Scroll attachments right", onClick: () => scroll('right') },
            React.createElement("i", { className: "fa-light fa-chevron-right" })))));
}
